import React, { useEffect, useRef, useState } from "react";
import Layout from "./Layout";
import {
  CasinoNew,
  Fishing,
  FishingNew,
  FishingPlatform,
  HomeCasino,
  HomeIconList,
  LiveCasino,
  LiveCasinoPlatform,
  PlatformObject,
  SlotNew,
  Slots,
  SlotsPlatform,
} from "./casino/CasinoList";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isEmpty, lowerCase } from "lodash";
import { toast } from "react-toastify";
import { useInfiniteScroll } from "../component/useInfiniteScroll";
import { IoMdFlame } from "react-icons/io";
import { t } from "i18next";
const CasinoMobile = ({ category } = {}) => {
  const [show, setShow] = useState("");
  const [inner, setInner] = useState("FC");
  const location = useLocation();
  const { type: routeType } = useParams();
  const type = category || routeType;
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const setCasinoBefore = useContextSelector(
    AuthContext,
    (ctx) => ctx.setCasinoBefore,
  );
  const launchCasino = useContextSelector(
    AuthContext,
    (ctx) => ctx.launchCasino,
  );
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const params = new URLSearchParams(location.search);
  const innerType = params.get("type") || "";
  const navigate = useNavigate();
  const objectTitle = {
    hot: "Hot Games",
    jili: "JILI Slots",
    pg: "PG Slots",
    slots: "Slots",
    live: "Live",
    fish: "Fish",
    poker: "Poker",
    sports: "Sports",
  };
  const objectTitleBn = {
    hot: "জনপ্রিয় গেমস",
    jili: "জিলি স্লটস",
    pg: "পিজি স্লটস",
    slots: "স্লটস",
    live: "লাইভ",
    fish: "ফিশ",
    poker: "পোকার",
    sports: "খেলাধুলা",
  };
  const objectList = {
    hot: HomeCasino?.HotGame,
    jili: HomeCasino?.JiliSlots,
    pg: HomeCasino?.PGSlots,
    slots: [...Slots, ...SlotNew],
    live: LiveCasino,
    fish: Fishing,
    poker: HomeCasino?.Poker,
    sports: HomeCasino?.Sports,
  };
  //  console.log(Slots?.length,'Slots')
  //  console.log(LiveCasino?.length,'LiveCasino');
    // console.log(Fishing?.length,'Fishing')
  //    console.log(Slots?.length,'Slots')
  //    console.log(Slots?.length,'Slots')

  function getUniqueFromSecond(arr1, arr2) {
    const normalize = (name) => name.replace(/\s+/g, "").toLowerCase();
    const nameSet = new Set(arr1.map((item) => normalize(item.name)));

    const updated = arr2.filter((item) => !nameSet.has(normalize(item.name)));
    return updated;
    // return updated.map((item) => ({
    //   name: item.name,
    //   img: item?.img,
    //   platForm: item.platForm,
    //   type: "CASINO",
    //   gameType: item.gameType,
    //   casinoType: item.casinoType,
    //   platFormCode: item.platForm,
    // }));
  }

  function getUniquePlatformCodes(arr) {
    return [...new Set(arr.map((item) => item.platForm))];
  }

  // console.log(getUniquePlatformCodes(Fishing));
  // console.log(getUniqueFromSecond(Fishing, FishingNew));

  function getUniquePlatformMap(arr) {
    return arr.reduce((acc, item) => {
      if (!acc[item.platForm]) {
        acc[item.platForm] = "";
      }
      return acc;
    }, {});
  }

  const result = getUniquePlatformMap(SlotNew);
  // console.log(result);

  const loadingRef = useRef(false);
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(30);
  const [list, setList] = useState([]); // original list (based on type)
  const [searchTerm, setSearchTerm] = useState(""); // current search text
  const [filteredList, setFilteredList] = useState([]); // filtered list after search
  const [hasMore, setHasMore] = useState(true);
  // ✅ Load casino list when type changes

  useEffect(() => {
    if (!isEmpty(type)) {
      setShow(type);
    }
    setInner(innerType || ({ slots: "FC", live: "EVO", fish: "JILI" })[type] || "all");
  }, [type, innerType]);

  useEffect(() => {
    if (!isEmpty(show)) {
      let data = ["slots", "live", "fish"].includes(lowerCase(show))
        ? objectList[lowerCase(show)]?.filter((res) => {
            return res?.platForm == inner;
          })
        : objectList[lowerCase(show)];
      setList(data);
      setFilteredList(data);
      setVisible(30);
      setSearchTerm("");
      setHasMore(true);
    }
  }, [show, inner]);

  // ✅ Search filter
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredList(list);
    } else {
      const lowerSearch = searchTerm.toLowerCase();
      const filtered = list.filter(
        (game) =>
          game?.title?.toLowerCase().includes(lowerSearch) ||
          game?.name?.toLowerCase().includes(lowerSearch),
      );
      setFilteredList(filtered);
    }
    setVisible(30); // reset visible count on new search
    setHasMore(true); // enable more data for search results
  }, [searchTerm, list]);

  // ✅ Load more for filtered list
  const loadMore = () => {
    if (loadingRef.current) return;

    setLoader(true);
    loadingRef.current = true;

    setTimeout(() => {
      setVisible((prev) => {
        const next = prev + 30;
        if (next >= filteredList.length) {
          setHasMore(false);
        }
        setLoader(false);
        return next;
      });
      loadingRef.current = false;
    }, 800);
  };

  // ✅ Limit visible games
  const visibleList = filteredList.slice(0, visible);

  // Infinite scroll hook
  const loaderRef = useInfiniteScroll(loadMore, hasMore);

  // ✅ Launch game or show login
  const handleGameClick = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error("Coming Soon");
      } else {
        if (!isEmpty(res?.gameid)) {
          // Specific game logic (optional)
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType,
          });
        }
      }
    } else {
      navigate("/auth/login");
    }
  };

  return (
    <Layout>
      <div className={`slotsCenter-wrap ${type === "hot" ? "chorki-hot-mobile" : ""}`}>
        {type === "hot" && <header className="chorki-hot-heading"><span className="chorki-hot-eyebrow">CHORKI COLLECTION</span><h1>{lang === "bn" ? "জনপ্রিয় গেমস" : "Hot Games"}</h1><p>{lang === "bn" ? "আপনার পছন্দের গেম খুঁজে নিন" : "Discover your next favorite game"}</p></header>}
        <div className="game-page-menu">
          <ul className="game-page-menu-list hide-scrollbar">
            {HomeIconList?.map((res) => {
              return (
                <li
                  onClick={() => {
                    setShow(res?.key);
                    if (res?.key == "slots") {
                      setInner("FC");
                    } else if (res?.key == "live") {
                      setInner("EVO");
                    } else if (res?.key == "fish") {
                      setInner("JILI");
                    } else {
                      setInner("");
                    }
                  }}
                  className={`game-page-menu-item ${
                    show == res?.key ? "on" : ""
                  }`}
                >
                  <div className="game-menu-icon">{res?.image}</div>
                  <span className="game-menu-name">
                    {lang == "en" ? res?.title : res?.titleBn}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="slots-content-wrap">
          <div className="game-title-wrap">
            <h2 className="game-title-text">
              {objectTitle[lowerCase(show)] == "JILI Slots" ? (
                <img
                  src="data:image/png;base64,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"
                  className="icon"
                />
              ) : objectTitle[lowerCase(show)] == "PG Slots" ? (
                <img
                  src="data:image/png;base64,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"
                  className="icon"
                />
              ) : objectTitle[lowerCase(show)] == "Hot Games" ? (
                <IoMdFlame
                  size={20}
                  color="#38a6fb"
                  style={{ marginRight: "5px" }}
                />
              ) : (
                <img
                  className="icon"
                  style={{ width: ".40rem", height: ".40rem" }}
                  src={
                    lowerCase(show) == "fish"
                      ? "/assets/Icon/fishing.svg"
                      : lowerCase(show) == "live"
                        ? "/assets/Icon/live-casino.svg"
                        : lowerCase(show) == "slots"
                          ? "/assets/Icon/slots.svg"
                          : lowerCase(show) == "poker"
                            ? "/assets/Icon/poker.svg"
                            : lowerCase(show) == "sports"
                              ? "/assets/Icon/sports.svg"
                              : ""
                  }
                />
              )}
              <span>
                {lang == "en"
                  ? objectTitle[lowerCase(show)]
                  : objectTitleBn[lowerCase(show)]}
              </span>
              <div className="slash" />
              <div className="total-game">
                <span className="amount">{list?.length}</span>
                <span>{t("Games")}</span>
              </div>
            </h2>
          </div>
          <div className="search-input-wrap">
            <svg className="am-icon am-icon-search_d83b5f3c am-icon-md search-icon">
              <use xlinkHref="#search_d83b5f3c" />
            </svg>
            <input
              type="text"
              className="search-input"
              aria-label={t("SearchGames")}
              autoComplete="off"
              placeholder={t("SearchGames")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>{" "}
          {["slots", "live", "fish"].includes(lowerCase(show)) && (
            <div class="scroll-menu-wrap hide-scrollbar gamePage">
              {(lowerCase(show) == "slots"
                ? SlotsPlatform
                : lowerCase(show) == "fish"
                  ? FishingPlatform
                  : LiveCasinoPlatform
              )?.map((res) => {
                return (
                  <div
                    onClick={() => setInner(res?.key)}
                    class={`menu-list-item swiper-slide ${
                      inner == res?.key ? "on" : ""
                    }`}
                  >
                    <div class="item-bg">
                      <img src={res?.img} alt="" />
                      <span>{res?.name}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <div className="slots-content">
            {show == "sports" ? (
              <div className="slots-content thirdGame">
                <div className="third-game-wrap">
                  <ul className="third-game-list SPORTS">
                    <div
                      onClick={() => (window.location.href = "/sports-velkie")}
                      className="vendor-item"
                    >
                      <img
                        className="vendor-bg"
                        src="/assets/images/velkie-bg-sports.png"
                        alt
                      />
                      <p className="vendor-name">Velkie</p>
                    </div>{" "}
                    <div
                      onClick={() => (window.location.href = "/sports-sky")}
                      className="vendor-item"
                    >
                      <img
                        className="vendor-bg"
                        src="/assets/images/gcs__sports-u9w_1719217004910.webp"
                        alt
                      />
                      <p className="vendor-name">9wickets</p>
                    </div>
                  </ul>
                </div>
              </div>
            ) : (
              <div className="slots-games">
                <div className="game-list-wrapper">
                  <div className="game-list">
                    {visibleList.length > 0 &&
                      visibleList.map((res, i) => (
                        <div
                          onClick={() => handleGameClick(res)}
                          key={res?.name || i}
                          role="button"
                          tabIndex={0}
                          aria-label={res?.name || res?.title}
                          onKeyDown={event => { if (["Enter", " "].includes(event.key)) { event.preventDefault(); handleGameClick(res); } }}
                          className="game-list-item "
                        >
                          <div className="game-list-img">
                            <img
                              className="game-img"
                              src={res?.img}
                              alt={res?.name || res?.title || "Game"}
                              loading="lazy"
                            />
                            <div className="game-vassalage">
                              <img
                                src={
                                  isEmpty(res?.vendor)
                                    ? PlatformObject[res?.platForm]
                                    : res?.vendor
                                }
                                alt=""
                              />
                            </div>
                            {/* <svg className="am-icon am-icon-icon-heart_07201eda am-icon-md favorite_icon">
                              <use xlinkHref="#icon-heart_07201eda" />
                            </svg> */}
                          </div>
                          <div className="game-item-name">{res?.name}</div>
                        </div>
                      ))}
                  </div>

                  {visibleList?.length == 0 && (
                    <div class="noData">
                      <div class="no-data-content">
                        <img src="/assets/images/no-data.75343940.png" alt="" />
                        <p>No data</p>
                      </div>
                    </div>
                  )}
                  {hasMore && (
                    <div
                      ref={loaderRef}
                      _ngcontent-serverapp-c302379289=""
                      class="list-loading ng-star-inserted"
                    />
                  )}
                  {loader && (
                    <div className="scroll-loading">
                      <svg
                        className="loading-icon"
                        x="0px"
                        y="0px"
                        width="40px"
                        height="40px"
                        viewBox="0 0 40 40"
                        enableBackground="new 0 0 40 40"
                      >
                        <path
                          opacity="0.2"
                          d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                        />
                        <path d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z">
                          <animateTransform
                            attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 20 20"
                            to="360 20 20"
                            dur="0.5s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CasinoMobile;
